import { Tooltip } from "#components/Tooltip";

import StackletPacksIcon from "../assets/stacklet_packs.svg?react";

interface SystemIconProps {
  type: "policy" | "binding" | "policy-collection" | "repository";
  size?: number | string;
}

function formatType(type: string): string {
  return type
    .replace("-", " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function SystemIcon({ type, size = 14 }: SystemIconProps) {
  const title = `This is a System ${formatType(type)}, used internally by the Stacklet Platform.`;

  return (
    <Tooltip title={title}>
      <StackletPacksIcon height={size} width={size} />
    </Tooltip>
  );
}
